import { lazy } from "react";

export const Banner = lazy(() => import("./Banner"));
